<h1>Access Denied</h1>
<h2>You do not have the necessary permissions to access this application</h2>
<button mat-raised-button (click)="logout()">Log Out</button>
